<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  add,
  getWarehouse,
  getDetails,
  update,
  del
} from "@/api/storage/warehouse";
import { getCountry } from "@/api/system/country";
import { getCity } from "@/api/system/city";
import cTable from "@/base/common/index";
export default {
  name: "warehouse",
  components: {
    cTable
  },
  async mounted() {},
  methods: {},
  data() {
    let statusList = [
        { label: this.$t("enable"), value: "ENABLE" },
        { label: this.$t("disable"), value: "DISABLE" }
      ],
      overseaList = [
        { label: "YES", value: "YES" },
        { label: "NO", value: "NO" }
      ];
    return {
      methods: {
        list: getWarehouse,
        add,
        update,
        getDetails,
        del,
        getCountry,
        getCity
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            listFn: "",
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  type: "string",
                  message: "title cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 3,
                  max: 55,
                  message: "Please Minimum length 3 and maximum length 55",
                  trigger: "blur"
                }
              ],
              title_en: [
                {
                  required: true,
                  type: "string",
                  message: "title cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 3,
                  max: 55,
                  message: "Please Minimum length 3 and maximum length 55",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  type: "string",
                  message: "warehouse_code cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 3,
                  max: 5,
                  message: "Please Minimum length 3 and maximum length 5",
                  trigger: "blur"
                }
              ],
              country_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the country",
                  trigger: "change"
                }
              ],
              city_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the city",
                  trigger: "change"
                }
              ],
              status: [
                {
                  required: true,
                  type: "string",
                  message: "is unique cannot be empty",
                  trigger: "change"
                }
              ],
              is_oversea: [
                {
                  required: true,
                  type: "string",
                  message: "is oversea cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { title: 24 },
            { title_en: 24 },
            { code: 24 },
            { country_id: 24 },
            { city_id: 24 },
            { province: 24 },
            { address: 24 },
            { zip_code: 24 },
            { status: 24 },
            { is_oversea: 24 }
          ],
          fields: [
            {
              key: "title",
              name: () => this.$t("warehouseName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("warehouseName");
              }
            },
            {
              key: "title_en",
              name: () => this.$t("warehouseName") + this.$t("En"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("warehouseName") + this.$t("En")
                );
              }
            },
            {
              key: "code",
              name: () => this.$t("warehouseCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("warehouseCode");
              }
            },
						{
						  key: "province",
						  name: () => this.$t("province"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("province");
						  }
						},
						{
						  key: "address",
						  name: () => this.$t("detailedAddress"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("detailedAddress");
						  }
						},
						{
						  key: "zip_code",
						  name: () => this.$t("zip_code"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("zip_code");
						  }
						},
            {
              key: "country_id",
              name: () => this.$t("countryName"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("countryName");
              },
              config: {
                label: "code",
                value: "id"
              },
              options: [],
              methods: {
                async list({ field, searchForm }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry")
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change"({ fields, value }) {
                  console.log("on-change", value);
                  fields.forEach(async ele => {
                    if (ele.key == "city_id") {
                      if (value) {
                        let res = await this.$page.handleRequestMethods(
                          "getCity",
                          { country_id: value }
                        );
                        ele.disabled = false;
                        ele.options = res.payload.rows;
                      } else {
                        ele.disabled = true;
                        ele.options = [];
                      }
                    }
                  });
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "city_id",
              name: () => this.$t("warehouseCity"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("warehouseCity");
              },
              disabled: true,
              config: {
                label: "title",
                value: "id"
              },
              options: []
            },
            {
              key: "status",
              name: () => this.$t("status"),
              component: "Radio",
              bind: {
                border: true
              },
              options: statusList,
              default: "ENABLE"
            },
            {
              key: "is_oversea",
              name: () => this.$t("is_oversea"),
              component: "Radio",
              bind: {
                border: true
              },
              options: overseaList,
              default: "YES"
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              id: 17,
              bind: {
                type: "primary",
                icon: "md-add"
              }
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              console.log(this);
              this.getModal("add").open(null, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("warehouseName"),
          key: "title",
          align: "center",
          minWidth: 100
        },
        // {
        //   name: this.$t("warehouseCode"),
        //   key: "code",
        //   align: "center",
        //   minWidth: 100
        // },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          align: "left",
          minWidth: 120,
          methods: {
            render({ row }) {
              return row.city ? row.city.title : " / ";
            }
          }
        },
				{
				  name: () => this.$t("province"),
				  key: "province",
				  align: "left",
				  minWidth: 120,
				
				},
				{
				  name: () => this.$t("detailedAddress"),
				  key: "address",
				  align: "left",
				  minWidth: 120,
				},
				{
				  name: () => this.$t("zip_code"),
				  key: "zip_code",
				  align: "left",
				  minWidth: 120,
				},
        {
          name: () => this.$t("countryCode"),
          key: "country_code",
          align: "center",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.country ? row.country.code : " / ";
            }
          }
        },
        {
          name: () => this.$t("countryTimezone"),
          key: "timezone",
          align: "left",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.timezone ? row.timezone.format : " / ";
            }
          }
        },
        {
          name: () => this.$t("is_oversea"),
          key: "is_oversea",
          align: "center",
          minWidth: 100,
          methods: {
            render({ value }) {
              return this.$t(value);
            }
          }
        },
        {
          name: () => this.$t("status"),
          key: "status",
          align: "center",
          minWidth: 100,
          methods: {
            render({ value }) {
              return this.$t(value);
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row }) {
              return this.format.timeFormat(row.create_time * 1000);
            }
          }
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row }) {
              return this.format.timeFormat(row.update_time * 1000);
            }
          }
        },
        {
          type: "btns",
          width: 120,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              id: 18,
              bind: {
                type: "success"
              }
            }
            // {
            //   name: () => this.$t("delete"),
            //   type: "delete",
            //   fnName: "deleteFun",
            //   bind: {
            //     type: "error"
            //   }
            // }
          ],

          methods: {
            async updateFun({ row }) {
              let res = await this.handleRequestMethods("getDetails", row.id);
              this.getModal("add").open(res.payload, function() {
                console.log("updateFun", this);
                this.fields.forEach(async ele => {
                  if (ele.key == "city_id") {
                    if (res.payload.country_id) {
                      let data = await this.$page.handleRequestMethods(
                        "getCity",
                        { country_id: res.payload.country_id }
                      );
                      ele.disabled = false;
                      ele.options = data.payload.rows;
                    } else {
                      ele.disabled = true;
                      ele.options = [];
                    }
                  }
                });
                this.setTitle(this.$t("update"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  '"' +
                  row.tracker_code +
                  '"' +
                  this.$t("tracker_code") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
